export const TABLE_UPDATE = "GASTROHUBLOCATIONS/TABLE_UPDATE";
export const FETCH_SUCCESS = "GASTROHUBLOCATIONS/FETCH_SUCCESS";

const types = {
    DESTROY_FAILED: "GASTROHUBLOCATIONS/DESTROY_FAILED",
    DESTROY_REQUEST: "GASTROHUBLOCATIONS/DESTROY_REQUEST",
    DESTROY_SUCCESS: "GASTROHUBLOCATIONS/DESTROY_SUCCESS",

    FETCH_FAILED: "GASTROHUBLOCATIONS/FETCH_FAILED",
    FETCH_REQUEST: "GASTROHUBLOCATIONS/FETCH_REQUEST",
    FETCH_SUCCESS,

    GET_FAILED: "GASTROHUBLOCATIONS/GET_FAILED",
    GET_REQUEST: "GASTROHUBLOCATIONS/GET_REQUEST",
    GET_SUCCESS: "GASTROHUBLOCATIONS/GET_SUCCESS",

    PATCH_FAILED: "GASTROHUBLOCATIONS/PATCH_FAILED",
    PATCH_REQUEST: "GASTROHUBLOCATIONS/PATCH_REQUEST",
    PATCH_SUCCESS: "GASTROHUBLOCATIONS/PATCH_SUCCESS",

    STORE_FAILED: "GASTROHUBLOCATIONS/STORE_FAILED",
    STORE_REQUEST: "GASTROHUBLOCATIONS/STORE_REQUEST",
    STORE_SUCCESS: "GASTROHUBLOCATIONS/STORE_SUCCESS",

    UPDATE_FAILED: "GASTROHUBLOCATIONS/UPDATE_FAILED",
    UPDATE_REQUEST: "GASTROHUBLOCATIONS/UPDATE_REQUEST",
    UPDATE_SUCCESS: "GASTROHUBLOCATIONS/UPDATE_SUCCESS",
    TABLE_UPDATE,
};

export default types;
